export default function ExitIcon() {
  return (
    <svg viewBox="0 0 313.93 332.62" xmlSpace="preserve" width={313.93}>
      <path
        style={{
          fill: '#fff',
          fillOpacity: 1,
        }}
        transform="matrix(.58475 0 0 .58475 673.217 -26.703)"
        d="M-862.41 285.75v37.85h68.46v20.31l68.05-39.24-68.05-39.22v20.3z"
      />
      <path
        style={{
          fill: '#fff',
          fillOpacity: 1,
        }}
        d="M907.089 598.352h-78.14v-185.27l-73.72-41.51h151.86v73.04h27.52v-100.56h-227.88v.21l-.08-.05.05 281.48.03.01v.16h.39l121.83 50.81v-50.81h105.67v-103.04h-27.52v75.53zm-108.88-45.69c-6.15 0-11.14-4.99-11.14-11.14s4.99-11.14 11.14-11.14 11.14 4.99 11.14 11.14c.01 6.15-4.98 11.14-11.14 11.14z"
        transform="matrix(.58475 0 0 .58475 -348.03 -132.122)"
      />
    </svg>
  )
}
